import { render, staticRenderFns } from "./Photo.vue?vue&type=template&id=6e33fbd2"
import script from "./Photo.vue?vue&type=script&lang=js"
export * from "./Photo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports